import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  isYesterday,
} from "date-fns";

export const formatDate = Intl.DateTimeFormat("en-US").format;

export const formatDateShort = Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
}).format;

export const formatDateLong = Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
}).format;

export const formatPrice = Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
}).format;

export const formatDateTime = Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
}).format;

export const formatTime = Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "numeric",
}).format;

export const formatTimePassedRelative = (date: Date) => {
  const now = new Date();
  const minutesPassed = differenceInMinutes(now, date);
  const hoursPassed = differenceInHours(now, date);
  const daysPassed = differenceInDays(now, date);

  return minutesPassed < 60
    ? `${minutesPassed} ${minutesPassed === 1 ? "minute ago" : "minutes ago"}`
    : hoursPassed < 24
      ? `${hoursPassed} ${hoursPassed === 1 ? "hour ago" : "hours ago"}`
      : isYesterday(date)
        ? `Yesterday at ${formatTime(date)}`
        : `${daysPassed} days ago`;
};
